/*
 * Islamboekhandel – 3-staffel voordeelbalk in winkelwagen (pagina + zijbalk).
 * Vervangt de oorspronkelijke enkele gratis-verzending-progressbar van het thema.
 * Staffels en teksten komen uit snippets/free-shipping-component.liquid.
 * Element-naam <free-shipping-component> en methodes initialize/onCartChange/calculateProgress
 * blijven bestaan zodat bestaande thema-code blijft werken.
 */
(function () {
  if (window.customElements && customElements.get('free-shipping-component')) return;

  var instances = new Set();
  var timer = null;
  var inflight = null;
  var CART_WRITE_RE = /\/cart\/(add|change|update|clear)/;

  function money(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.money_format) {
        return Shopify.formatMoney(cents, window.money_format);
      }
    } catch (e) {}
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: cur }).format(cents / 100);
  }

  // Totaal na kortingen, exclusief cadeaubonnen (zoals het thema ook deed).
  function totalFromCart(cart) {
    var t = cart.total_price || 0;
    (cart.items || []).forEach(function (i) {
      if (i.gift_card) t -= (i.final_line_price || i.line_price || 0);
    });
    return Math.max(0, t);
  }

  function renderAll(total) {
    instances.forEach(function (el) { el.render(total); });
  }

  // Header-teller (en zijbalk-titel) gelijk houden met de echte winkelwagen.
  // Het thema werkt die alleen bij in z'n eigen toevoeg-flow; wijzigingen door apps
  // (bv. automatisch toegevoegd gratis cadeau) of via de winkelwagenpagina bleven anders hangen.
  function syncCartCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    var n = cart.item_count;
    var cs = window.cartStrings || {};
    var word = n === 1 ? (cs.item || 'artikel') : (cs.items || 'artikelen');
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      var inBubble = el.closest && el.closest('.cart-count-bubble');
      var txt = inBubble && n >= 100 ? (cs.item_99 || '99+') : String(n);
      if (el.textContent !== txt) el.textContent = txt;
    });
    document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach(function (el) {
      el.textContent = n + ' ' + word;
    });
    document.querySelectorAll('[data-cart-text]').forEach(function (el) {
      el.textContent = word;
    });
  }

  function refreshAll(cart) {
    if (cart && typeof cart.total_price === 'number') {
      renderAll(totalFromCart(cart));
      syncCartCount(cart);
      return Promise.resolve();
    }
    if (inflight) return inflight;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    inflight = fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderAll(totalFromCart(c)); syncCartCount(c); })
      .catch(function () {})
      .then(function () { inflight = null; });
    return inflight;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { refreshAll(); }, 350);
  }

  // Luister naar alle winkelwagen-wijzigingen (fetch, XHR/jQuery) van thema en apps.
  if (window.fetch && !window.__ibTiersFetchPatched) {
    window.__ibTiersFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (CART_WRITE_RE.test(url)) p.then(schedule, schedule);
      return p;
    };
  }
  if (window.XMLHttpRequest && !window.__ibTiersXhrPatched) {
    window.__ibTiersXhrPatched = true;
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (CART_WRITE_RE.test(String(url || ''))) {
        this.addEventListener('loadend', schedule);
      }
      return origOpen.apply(this, arguments);
    };
  }
  ['cart:updated', 'cart:refresh', 'cart-update', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });
  // Na laden (apps die al vóór dit script iets toevoegden) en bij terug-knop (bfcache).
  window.addEventListener('load', function () { setTimeout(schedule, 1500); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });

  class IBTiers extends HTMLElement {
    connectedCallback() {
      var cfgEl = this.querySelector('[data-ib-tiers-config]');
      try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
      this.msg = this.querySelector('[data-shipping-message]');
      this.track = this.querySelector('[data-ib-track]');
      this.fills = Array.prototype.slice.call(this.querySelectorAll('[data-ib-fill]'));
      this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-ib-step]'));
      instances.add(this);

      var initial = parseInt(this.dataset.cartTotal, 10);
      if (!isNaN(initial)) this.render(initial);

      if (!this._bound) {
        this._bound = true;
        this.addEventListener('change', function () { refreshAll(); });
      }
      refreshAll();
    }

    disconnectedCallback() { instances.delete(this); }

    // Compatibiliteit met oorspronkelijke FreeShippingMeter-API
    initialize() { return refreshAll(); }
    onCartChange() { return refreshAll(); }
    calculateProgress(cart) { return refreshAll(cart); }

    render(totalCents) {
      if (!this.cfg) return;
      var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
      var tiers = this.cfg.tiers.map(function (a) { return Math.round(a * 100 * rate); });
      var reached = 0;
      tiers.forEach(function (t, i) { if (totalCents >= t) reached = i + 1; });

      var self = this;
      tiers.forEach(function (t, i) {
        var start = i ? tiers[i - 1] : 0;
        var pct = Math.max(0, Math.min(100, ((totalCents - start) / (t - start)) * 100));
        var done = totalCents >= t;
        if (self.fills[i]) {
          self.fills[i].style.width = pct + '%';
          self.fills[i].parentNode.classList.toggle('is-done', done);
        }
        if (self.steps[i]) {
          self.steps[i].classList.toggle('is-done', done);
          self.steps[i].classList.toggle('is-next', i === reached && totalCents > 0);
        }
      });

      var T = this.cfg.text;
      var html;
      if (totalCents <= 0) {
        html = T.empty;
      } else if (reached >= tiers.length) {
        html = T.done;
      } else {
        html = T['to_' + reached].replace('{amount}', '<strong class="ib-tiers__left">' + money(tiers[reached] - totalCents) + '</strong>');
      }
      if (this.msg) this.msg.innerHTML = html;
      this.classList.toggle('is-empty', totalCents <= 0);
      this.classList.toggle('is-complete', reached >= tiers.length);
      this.dataset.reached = String(reached);
      if (this.track) this.track.setAttribute('aria-valuenow', (totalCents / 100).toFixed(2));
    }
  }

  customElements.define('free-shipping-component', IBTiers);
})();
